// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"fuEjlz","container":"OpopWS","error":"BKYeCQ","hover":"vENWvg"};